/**
 * SOFSEK — External-system attributes on the platform page/function record.
 *
 * A page is a page: migration 20260821000000 parked the ~8.5k external-system
 * functions ("actions") into `csm_page_master` as non-navigable rows, with the
 * SOFSEK-only attributes on the 1:1 sister `sfk_action` — the function's
 * `platform_signature` in the source system and whether it is excluded from
 * single-point-of-failure analysis. An external function is simply a
 * csm_page_master row whose application is an external system.
 *
 * This manifest makes the single inherited Pages screen (CSM.PAGE.MASTER, which
 * is already application-aware) show those attributes without SOFSEK forking the
 * page (§16). It replaces the old SOFSEK-owned SFK.ACTION.LIST page, retired in
 * the same change.
 */
import { registerRecordExtension } from '../../lib/record_extensions';

registerRecordExtension({
  key: 'sfk_action',
  page_code: 'CSM.PAGE.MASTER',
  entity: 'csm_page_master',
  sister: { table: 'sfk_action', pk: 'page_id' },
  section_label_key: 'sfk.action.section',
  section_label_default: 'External Function',
  fields: [
    {
      // The function's signature in the source system (its stable identifier).
      key: 'platform_signature',
      label_key: 'sfk.action.signature',
      label_default: 'Platform Signature',
      kind: 'text',
      grid: true,
      grid_width: 180,
    },
    {
      // Excluded from single-point-of-failure (SPOF) analysis.
      key: 'is_excluded_from_spof',
      label_key: 'sfk.action.spof_excluded',
      label_default: 'SPOF-Excluded',
      kind: 'yn',
      grid: true,
      grid_width: 120,
      facet: true,
    },
  ],
});
